/**
 * Global prototype constants live here so scenes, UI, and simulation
 * all read from the same set of tuning knobs.
 */
export const SLOT_IDS = ["slot-1", "slot-2", "slot-3"];
export const PROTOTYPE_ROSTER_CAP = 6;
export const PROTOTYPE_RUN_GOAL = 10;
export const DEFAULT_SAVE_VERSION = 1;
export const ENEMY_STARTING_FUNDS = 0;
export const SKIRMISH_DEFAULT_STARTING_FUNDS = 1200;
export const SKIRMISH_DEFAULT_FUNDS_PER_BUILDING = 100;
export const COMMANDER_POWER_MAX = 70;
export const ENEMY_RECRUITMENT_EARLY_LIMIT = 1;
export const ENEMY_RECRUITMENT_STANDARD_LIMIT = 2;
export const ENEMY_RECRUITMENT_UNIT_LEAD_LIMIT = 2;
export const ENEMY_RECRUITMENT_BASE_MAP_CAP = 3;
export const ENEMY_RECRUITMENT_MAP_CAP_STEP_INTERVAL = 2;
export const ENEMY_RECRUITMENT_MAX_MAP_CAP = 7;
// Keep the JS timing values aligned with the turn-banner CSS animation.
export const BATTLE_TURN_BANNER_DISPLAY_MS = 1100;
export const BATTLE_TURN_BANNER_SETTLE_MS = 1120;
export const BATTLE_FUNDS_GAIN_ANIMATION_MS = 900;
export const BATTLE_NOTICE_DISPLAY_MS = 2100;
export const BATTLE_POWER_OVERLAY_DISPLAY_MS = 1700;
export const APP_TOAST_DISPLAY_MS = 2400;
export const BATTLE_REINFORCEMENT_NOTICE_MS = 1400;
export const BATTLE_REINFORCEMENT_NOTICE_TO_SPAWN_MS = 420;
export const BATTLE_REINFORCEMENT_SPAWN_STAGGER_MS = 560;
export const BATTLE_REINFORCEMENT_SPAWN_FLASH_MS = 320;
// Movement timing is shared between Phaser tweens and the enemy turn queue.
export const BATTLE_MOVE_SEGMENT_DURATION_MS = 230;
export const BATTLE_MOVE_SETTLE_MS = 70;
export const BATTLE_ENEMY_MOVE_STEP_PAUSE_MS = 260;
export const BATTLE_ATTACK_IMPACT_DELAY_MS = 140;
export const BATTLE_ATTACK_WINDOW_MS = 620;
export const BATTLE_COMBAT_CUTSCENE_FOCUS_IN_MS = 360;
export const BATTLE_COMBAT_CUTSCENE_FOCUS_OUT_MS = 220;
export const BATTLE_COMBAT_CUTSCENE_OPEN_MS = 240;
export const BATTLE_COMBAT_CUTSCENE_CLOSE_MS = 220;
export const BATTLE_COMBAT_CUTSCENE_INTRO_HOLD_MS = 200;
export const BATTLE_COMBAT_CUTSCENE_OUTRO_HOLD_MS = 250;
export const BATTLE_COMBAT_CUTSCENE_SHAKE_MS = 150;
export const BATTLE_COMBAT_CUTSCENE_STEP_WINDOW_MS = 960;
export const BATTLE_COMBAT_CUTSCENE_IMPACT_DELAY_MS = 360;
export const BATTLE_COMBAT_CUTSCENE_LOOP_MIN = 4;
export const BATTLE_COMBAT_CUTSCENE_LOOP_MAX = 5;
export const BATTLE_POST_COMBAT_PAUSE_MS = 180;

export function getBattleMoveDuration(moveSegments = 0) {
  return Math.max(0, moveSegments) * BATTLE_MOVE_SEGMENT_DURATION_MS;
}

export const BUILDING_INCOME = {
  sector: 100,
  command: 100,
  barracks: 100,
  "motor-pool": 100,
  airfield: 100,
  hospital: 100,
  "repair-station": 100,
};

export const SCREEN_IDS = {
  TITLE: "title",
  TUTORIAL: "tutorial",
  COMMANDER_SELECT: "commander-select",
  RUN_LOADOUT: "run-loadout",
  SKIRMISH_SETUP: "skirmish-setup",
  LOAD_SLOT: "load-slot",
  OPTIONS: "options",
  PROGRESSION: "progression",
  MAP_EDITOR: "map-editor",
  BATTLE: "battle",
};

export const BATTLE_MODES = {
  RUN: "run",
  SKIRMISH: "skirmish",
  TUTORIAL: "tutorial",
};

export const TURN_SIDES = {
  PLAYER: "player",
  ENEMY: "enemy",
};

export const ENEMY_AI_ARCHETYPES = {
  BALANCED: "balanced",
  HYPER_AGGRESSIVE: "hyper-aggressive",
  TURTLE: "turtle",
  CAPTURE: "capture",
  HQ_RUSH: "hq-rush",
};

export const ENEMY_AI_ARCHETYPE_ORDER = [
  ENEMY_AI_ARCHETYPES.BALANCED,
  ENEMY_AI_ARCHETYPES.HYPER_AGGRESSIVE,
  ENEMY_AI_ARCHETYPES.TURTLE,
  ENEMY_AI_ARCHETYPES.CAPTURE,
  ENEMY_AI_ARCHETYPES.HQ_RUSH,
];

export const TERRAIN_KEYS = {
  PLAIN: "plain",
  ROAD: "road",
  FOREST: "forest",
  MOUNTAIN: "mountain",
  WATER: "water",
  RIDGE: "ridge",
};

export const BUILDING_KEYS = {
  COMMAND: "command",
  BARRACKS: "barracks",
  MOTOR_POOL: "motor-pool",
  AIRFIELD: "airfield",
  SECTOR: "sector",
  HOSPITAL: "hospital",
  REPAIR_STATION: "repair-station",
};

export const UNIT_TAGS = {
  INFANTRY: "infantry",
  VEHICLE: "vehicle",
  AIR: "air",
};
